import react from 'react';
import {useEffect, useState} from 'react'
import MovieCard from './MovieCard.jsx';
import SearchIcon from './search.svg'
import './App.css';

// 27918d79

// here we create a static variable called api url then use "useEffect hook"
const API_URL = 'https://www.omdbapi.com/?i=tt3896198&apikey=27918d79';

const movie1 = {
  "Title": "Amazing Spiderman Syndrome",
  "Year": "2012",
  "imdbID": "tt286634",
  "Type": "movie",
  "Poster": "N/A"
}

//this is a useState hook
const App = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setSearchTerm] = useState ('');
  
  const searchMovies = async (title) => {
   const response = await fetch(`${API_URL}&s=${title}`)
   const data = await response.json();
    
   setMovies(data.Search);
  }
  
  useEffect(() => {
   searchMovies('Avengers')
  }, []);

  return (
    <div className="app">
      <h1>MovieLand</h1>

      <div className="search">
          <input 
          placeholder="Search for movies"
           value={searchTerm} 
          onChange={(e) => setSearchTerm(e.target.value)}
          />

           <img 
           src={SearchIcon} 
           alt="search" 
           onClick={() => searchMovies(searchTerm)}
           />
      </div>

      {
      movies?.length > 0
            ? (
            <div className="container">
             {movies.map((movie) => (
              <MovieCard movie={movie} />
             ))}
            </div>
         ) : (
           <div className="empty">
             <h2>No movies found</h2>
           </div>
         )}
    </div>
  );
}

export default App;
